import { render, staticRenderFns } from "./newbuilding.vue?vue&type=template&id=00578cab&scoped=true"
import script from "./newbuilding.vue?vue&type=script&lang=js"
export * from "./newbuilding.vue?vue&type=script&lang=js"
import style0 from "./newbuilding.vue?vue&type=style&index=0&id=00578cab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00578cab",
  null
  
)

export default component.exports